export default __webpack_public_path__ + "static/media/sca.f4349bb1.png";